import { atom } from 'jotai';

const metricReqBody = atom({});
const sessionReqBody = atom({});
const obfuscateIp = atom(true);
const obfuscateLocation = atom(true);
const customerType = atom('');
const alertsSessionAssociation = atom<
  Array<{ aiAlertId: string; impactedSessions: Array<string> }>
>([]);
const alertList = atom([]);
const metricLoading = atom(true);
const sessionsLoading = atom(true);
const sessionsResponse = atom<any>(null);

export {
  metricReqBody,
  sessionReqBody,
  obfuscateIp,
  obfuscateLocation,
  customerType,
  alertsSessionAssociation,
  alertList,
  metricLoading,
  sessionsLoading,
  sessionsResponse,
};
